/** TanStack Query keys for Stream bootstrap / chat (tokens are per authenticated user). */
export const streamKeys = {
  orderUnreadPrefix: ['stream-order-unread'] as const,
  orderUnread: (userID?: string, orderID?: string) =>
    ['stream-order-unread', userID ?? null, orderID ?? null] as const,
  userUnread: (userID?: string) =>
    ['stream-order-unread', userID ?? null] as const,
  orderChatPrefix: ['stream-order-chat'] as const,
  orderChat: (userID?: string, orderID?: string) =>
    ['stream-order-chat', userID ?? null, orderID ?? null] as const,
} as const
